import PlantCard from './PlantCard'
import { useI18n } from '../../i18n/I18nProvider'

function PlantList({ plants, onDestroy, onCollectSeed }) {
  const { t } = useI18n()
  if (plants.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-6">
        <h3 className="text-xl font-bold mb-4">{t('plantList.title')}</h3>
        <p className="text-gray-500 text-center">
          {t('plantList.noPlants')}
        </p>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h3 className="text-xl font-bold mb-4">{t('plantList.title')}</h3>
      <div className="space-y-4">
        {plants.map((plant) => (
          <PlantCard
            key={plant.id}
            plant={plant}
            onDestroy={onDestroy}
            onCollectSeed={onCollectSeed}
          />
        ))}
      </div>
    </div>
  )
}

export default PlantList
